// extracted by mini-css-extract-plugin
export default {"contentDescription":"ButtonLogout_contentDescription__-Vfyj","iconButton":"ButtonLogout_iconButton__b2wHV","animationIcon":"ButtonLogout_animationIcon__Fsjrt"};